/* Site-wide fixes (1 Nov 2026 audit).
   Size labels read EU first, the way Egyptian shoppers think in sizes:
   "M8 / W10 — (41)" -> "41 (M8 / W10)", "J3 — EU 34-35" -> "34–35 (J3)",
   "US10 (44-45)" -> "44–45 (US10)". Display only: the variants keep their names. */
(function () {
  'use strict';
  var SEL = '[data-ssr-size-name], [data-ssr-picked-value], [data-ssr-sticky-pick], [data-b-size-name], .ssr-line__variant, .ssr-bndl__chipval';
  var RX = [
    [/^(.+?)\s*—\s*\(\s*([\d][\d\s–-]*)\s*\)$/, '$2 ($1)'],
    [/^(.+?)\s*—\s*EU\s*([\d][\d\s–-]*)$/, '$2 ($1)'],
    [/^((?:US|M|W|J|C)\d+)\s*\(\s*([\d][\d\s–-]*)\s*\)$/, '$2 ($1)']
  ];
  function fixPart(s) {
    var t = s.trim();
    for (var i = 0; i < RX.length; i++) {
      if (RX[i][0].test(t)) {
        var out = t.replace(RX[i][0], RX[i][1]);
        out = out.replace(/(\d)\s*[-–]\s*(\d)/g, '$1–$2');
        return s.replace(t, out);
      }
    }
    return s;
  }
  function fixText(s) {
    if (s.indexOf(' · ') > -1) return s.split(' · ').map(fixPart).join(' · ');
    return fixPart(s);
  }
  function walk(el) {
    var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = tw.nextNode())) {
      var v = n.nodeValue;
      if (!v || v.indexOf('(') === -1 && v.indexOf('EU') === -1) continue;
      var f = fixText(v);
      if (f !== v) n.nodeValue = f;
    }
  }
  var busy = false;
  function run() {
    if (busy) return;
    busy = true;
    try { document.querySelectorAll(SEL).forEach(walk); } finally { busy = false; }
  }
  var t = null;
  function soon() { if (busy) return; clearTimeout(t); t = setTimeout(run, 30); }
  function start() {
    run();
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();